import React, { useState, useEffect } from 'react';
import '../styles/ActionItemList.css';

export interface ActionItem {
    id: string;
    text: string;
    completed: boolean;
}

interface ActionItemListProps {
    initialItems: ActionItem[];
    onChange: (items: ActionItem[]) => void;
}

const ActionItemList: React.FC<ActionItemListProps> = ({ initialItems, onChange }) => {
    const [items, setItems] = useState<ActionItem[]>(initialItems);

    useEffect(() => {
        setItems(initialItems);
    }, [initialItems]);

    const handleAddItem = () => {
        const newItem: ActionItem = {
            id: crypto.randomUUID(),
            text: '',
            completed: false
        };
        const newItems = [...items, newItem];
        setItems(newItems);
        onChange(newItems);
    };

    const handleUpdateItem = (id: string, field: keyof ActionItem, value: any) => {
        const newItems = items.map(item =>
            item.id === id ? { ...item, [field]: value } : item
        );
        setItems(newItems);
        onChange(newItems);
    };

    const handleDeleteItem = (id: string) => {
        const newItems = items.filter(item => item.id !== id);
        setItems(newItems);
        onChange(newItems);
    };

    return (
        <div className="action-item-list">
            {items.map((item) => (
                <div key={item.id} className={`action-item-row ${item.completed ? 'completed' : ''}`}>
                    <input
                        type="checkbox"
                        className="action-item-checkbox"
                        checked={item.completed}
                        onChange={(e) => handleUpdateItem(item.id, 'completed', e.target.checked)}
                    />
                    <div className="action-item-content">
                        <input
                            type="text"
                            className="action-item-input"
                            placeholder="Describe the action item..."
                            value={item.text}
                            onChange={(e) => handleUpdateItem(item.id, 'text', e.target.value)}
                        />
                    </div>
                    <button
                        className="btn-delete-action"
                        onClick={() => handleDeleteItem(item.id)}
                        title="Delete action item"
                    >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M18 6L6 18M6 6l12 12" />
                        </svg>
                    </button>
                </div>
            ))}

            <button className="add-action-btn" onClick={handleAddItem}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 5v14M5 12h14" />
                </svg>
                Add Action Item
            </button>
        </div>
    );
};

export default ActionItemList;
